export default __webpack_public_path__ + "static/media/Tigger.24fd5f7d.jpg";